// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { MainPanel, MainPanelContent } from '@tectonics/look-and-feel/volcanes/template';
import { MobileDisplayValues } from '@tectonics/look-and-feel/volcanes/organisms/mobile-display-values';
import { Header } from '@tectonics/look-and-feel/volcanes/organisms/header';
import smartphoneCheck from './images/smartphone-check.svg';
import smartphonePin from './images/smartphone-pin.svg';
import speechInfo from './images/speech-info.svg';
import { type IncomingPayment, usePendingIncomingPayment, getPhoneNumber, getPaymentTypeCode } from '@tectonics/prs/incoming-payment';
import { OtpRedirectPage } from './otp-redirect-page';

export function OtpFinish(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const phoneNumber = getPhoneNumberOrEmpty(incomingPayment);
  const paymentTypeCode = getPaymentTypeCode(incomingPayment);
  const isRedirectSimulatorTest = (ENV_CONSTANTS.ENV !== 'production'); 
  
  return (
    <MainPanel>
      <Header />
      <MobileDisplayValues />
      <MainPanelContent>
        <Root>
          <Body>
            <Title>Complete the payment in your mobile phone</Title>
            <InformationPhone>
              <InformationLine>
                <img style={{ height: '48px' }} alt="smartphone-check" src={smartphoneCheck} />
                <div style={{ marginLeft: '10px' }}>
                  Check your phone for a prompt sent to <b>+{phoneNumber}</b>
                </div>
              </InformationLine>
              <InformationLine>
                <img style={{ height: '48px' }} alt="smartphone-pin" src={smartphonePin} />
                <div style={{ marginLeft: '10px' }}>
                  Enter your PIN to authorize the mobile money transaction via {paymentTypeCode}
                </div>
              </InformationLine>
              <InformationLine>
                <img style={{ height: '48px' }} alt="speech-info" src={speechInfo} />
                <div style={{ marginLeft: '10px' }}>
                  Finish the payment by clicking the button below
                </div>
              </InformationLine>
            </InformationPhone>
            <ButtonGroup>
              {isRedirectSimulatorTest ? <OtpRedirectPage /> : <ButtonConfirmPaymentTag />}
            </ButtonGroup>
          </Body>
        </Root>
      </MainPanelContent>
    </MainPanel>
  );
}

function getPhoneNumberOrEmpty(incomingPayment: IncomingPayment): ?string {
  return getPhoneNumber(incomingPayment) || '';
}

function ButtonConfirmPaymentTag(): Node {
  return(
    <ButtonConfirmPayment onClick={() => window.location.reload()}>Confirm Payment</ButtonConfirmPayment>
  );
}

const InformationPhone = styled.div`
  flex-direction: column;
  display: inline-flex;
  border: 1px solid #d4d9e3;
  border-radius: 4px;
  margin-top: 20px;
  padding: 24px 16px 24px 16px;
  align-items: flex-start;
`;

const InformationLine = styled.div`
  margin: 10px;
  display: inline-flex;
  align-items: center;
`;

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colors.gray(20)};
`;

const Body = styled.div`
  padding: 32px 16px;
`;

const Title = styled.h1`
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
  color: #1e272c;
  font-family: Gilroy, "Open Sans", "OpenSans", Arial, "Helvetica Neue", Helvetica, sans-serif;
  margin-bottom: 5px;
  text-align: center;
`;

const ButtonGroup = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 24px 0 24px;
`;

const ButtonConfirmPayment = styled.button`
  color: #fff;
  display: flex;
  font-weight: 600;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;
  width: 220px;
  min-width: 220px;
  height: 46px;
  background: #0040ca;
  border-radius: 40px;
  border: 1px solid;
  flex: none;
  order: 0;
  flex-grow: 0;
  cursor: pointer;
  &:hover {
    filter: brightness(125%);
  }
`;
